document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector("[data-stats]");
  if (!section) return;

  const numbers = section.querySelectorAll(".stats-number");

  const animateNumber = (el) => {
    const target = parseInt(el.dataset.target);
    const duration = 1500;
    const start = performance.now();

    const step = (timestamp) => {
      const progress = Math.min((timestamp - start) / duration, 1);
      const value = Math.floor(progress * target);
      el.textContent = value.toLocaleString();

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = target.toLocaleString();
      }
    };

    requestAnimationFrame(step);
  };

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        numbers.forEach(num => animateNumber(num));
        obs.disconnect();
      }
    });
  }, { threshold: 0.4 });

  observer.observe(section);
});
